/**
 * Calculates progress percentage based on tracked and booked hours
 * @param tracked - Total tracked hours
 * @param booked - Total booked hours
 * @returns Progress percentage (can be > 100% when tracked > booked)
 */
export const calculateProgressPercentage = (tracked: number, booked: number): number => {
  if (booked > 0) {
    return (tracked / booked) * 100;
  }
  // No booked hours: 100% if anything was tracked, 0% otherwise
  return tracked > 0 ? 100 : 0;
};
